export default __webpack_public_path__ + "static/media/upi-image.357ac29f.png";